export const requestFormMockData: any = {
  data: {
    sections: [
      {
        name: 'Basic Information',
        show_condition: null,
        updated_field_keys: [],
        fields: [
          {
            type: 'dual_language_text',
            key: 'request_subject',
            label: 'Request Subject',
            tooltip: null,
            value: null,
            properties: [],
            can_answered: true,
            can_edit: true,
            is_required: true,
            multiple: null,
            show_condition: null,
            disable_condition: null,
          },
          {
            type: 'lookup',
            key: 'project_id',
            label: 'Select Project',
            tooltip: null,
            value: '8',
            properties: {
              options: {
                api: 'https://dib.api.dev.kuiper.areebholding.work/api/v1/lookup/projects?tenant=dib&access_throw=workflow',
                filters: [
                  {
                    key: 'is_in_blocking_states',
                    value: '0',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                  {
                    key: 'search',
                    value: null,
                    value_type: 'search',
                    multiple: false,
                    required: false,
                  },
                ],
                keys: {
                  label: 'label',
                  value: 'value',
                  icon: 'image',
                  tag: 'state',
                  hint: 'hint',
                  extraLabels: [
                    {
                      label: 'Project ID',
                      key: 'value',
                    },
                    {
                      label: 'Project Type',
                      key: 'type_name',
                    },
                    {
                      label: 'SPV Name',
                      key: 'spv_name',
                    },
                  ],
                },
              },
              on_select_data: [
                {
                  api: 'https://dib.api.dev.kuiper.areebholding.work/api/v1/application/projects/:project_id/roles?tenant=dib&access_throw=workflow',
                  filters: [],
                  replacement_keys: [],
                  data_type: 'array',
                  data_key: 'roles',
                },
                {
                  api: 'https://dib.api.dev.kuiper.areebholding.work/api/v1/application/projects/:project_id/definition?tenant=dib&access_throw=workflow',
                  filters: [],
                  replacement_keys: [],
                  data_type: 'object',
                  data_key: 'definition',
                },
                {
                  api: 'https://dib.api.dev.kuiper.areebholding.work/api/v1/application/projects/:project_id?tenant=dib&access_throw=workflow',
                  filters: [],
                  replacement_keys: [
                    {
                      search: 'legal_entity.id',
                      replace: 'legal_entity.value',
                    },
                    {
                      search: 'legal_entity.name',
                      replace: 'legal_entity.label',
                    },
                    {
                      search: 'parent.id',
                      replace: 'parent.value',
                    },
                    {
                      search: 'parent.name',
                      replace: 'parent.label',
                    },
                    {
                      search: 'parent.project_type.name',
                      replace: 'parent.type_name',
                    },
                    {
                      search: 'fund.developer.id',
                      replace: 'fund.developer.value',
                    },
                    {
                      search: 'fund.developer.name',
                      replace: 'fund.developer.label',
                    },
                  ],
                  data_type: 'object',
                  data_key: null,
                },
              ],
              relation_details: {
                value: 8,
                label: 'wwwwwwwwwwwwww',
                state: {
                  value: 'approved',
                  label: 'Approved',
                },
                spv_name: '',
                type_name: 'Fund',
                type_slug: 'fund',
                has_child_type: false,
                image: {
                  id: 53,
                  name: 'a7a8e5eb1c752b6b8cc70221d2ca03eaee261e9b.png',
                  mime_type: 'image/png',
                  url: 'https://dib.api.dev.kuiper.areebholding.work/storage/dib/53/a7a8e5eb1c752b6b8cc70221d2ca03eaee261e9b.png',
                  order: 1,
                },
              },
            },
            can_answered: true,
            can_edit: true,
            is_required: true,
            multiple: null,
            show_condition: null,
            disable_condition: null,
          },
        ],
      },
      {
        name: 'Project Info',
        show_condition: ":project_id.has_child_type == 'true'",
        updated_field_keys: [],
        fields: [
          {
            type: 'lookup-simple',
            key: 'legal_entity_id',
            label: 'Legal Entity',
            tooltip: null,
            value: null,
            properties: {
              options: {
                api: 'https://dib.api.dev.kuiper.areebholding.work/api/v1/lookup/legal-entities?tenant=dib&access_throw=workflow',
                filters: [
                  {
                    key: 'is_in_blocking_states',
                    value: '0',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                ],
                keys: {
                  label: 'label',
                  value: 'value',
                  icon: null,
                  tag: null,
                  hint: 'hint',
                  extraLabels: [],
                },
              },
              on_select_data: [],
              equation: ':project_id.legal_entity',
            },
            can_answered: true,
            can_edit: true,
            is_required: true,
            multiple: null,
            show_condition: null,
            disable_condition: null,
          },
          {
            type: 'drop_down_menu',
            key: 'project_state',
            label: 'Project State',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Project State',
              options: [
                {
                  value: 'approved',
                  label: 'Approved',
                },
                {
                  value: 'rejected',
                  label: 'Rejected',
                },
              ],
              equation: ':project_id.state.value',
            },
            can_answered: true,
            can_edit: true,
            is_required: true,
            multiple: null,
            show_condition: null,
            disable_condition: null,
          },
          {
            type: 'lookup',
            key: 'parent_id',
            label: 'Project Parent',
            tooltip: null,
            value: null,
            properties: {
              options: {
                api: 'https://dib.api.dev.kuiper.areebholding.work/api/v1/lookup/projects?tenant=dib&access_throw=workflow',
                filters: [
                  {
                    key: 'is_in_blocking_states',
                    value: '0',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                  {
                    key: 'search',
                    value: null,
                    value_type: 'search',
                    multiple: false,
                    required: false,
                  },
                  {
                    key: 'has_type.is_child',
                    value: '0',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                ],
                keys: {
                  label: 'label',
                  value: 'value',
                  icon: 'image',
                  tag: 'state',
                  hint: 'hint',
                  extraLabels: [
                    {
                      label: 'Project ID',
                      key: 'value',
                    },
                    {
                      label: 'Project Type',
                      key: 'type_name',
                    },
                    {
                      label: 'SPV Name',
                      key: 'spv_name',
                    },
                  ],
                },
              },
              on_select_data: [],
              equation: ':project_id.parent',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.has_child_type == 'true'",
            disable_condition: null,
          },
          {
            type: 'lookup-simple',
            key: 'sector_option_id',
            label: 'Project Sector',
            tooltip: null,
            value: null,
            properties: {
              options: {
                api: 'https://dib.api.dev.kuiper.areebholding.work/api/v1/lookup/variable-options?tenant=dib&access_throw=workflow',
                filters: [
                  {
                    key: 'is_in_blocking_states',
                    value: '0',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                  {
                    key: 'variable.module',
                    value: 'project',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                  {
                    key: 'variable.key',
                    value: 'sector',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                  {
                    key: 'is_active',
                    value: '1',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                ],
                keys: {
                  label: 'label',
                  value: 'value',
                  icon: null,
                  tag: null,
                  hint: 'hint',
                  extraLabels: [],
                },
              },
              on_select_data: [],
              equation: ':project_id.sector',
            },
            can_answered: true,
            can_edit: true,
            is_required: true,
            multiple: null,
            show_condition: null,
            disable_condition: null,
          },
          {
            type: 'dual_language_text',
            key: 'project_name',
            label: 'Project Name',
            tooltip: null,
            value: null,
            properties: {
              equation: ':project_id.translations.name',
            },
            can_answered: true,
            can_edit: true,
            is_required: true,
            multiple: null,
            show_condition: null,
            disable_condition: null,
          },
          {
            type: 'media',
            key: 'project_image',
            label: 'Project Image',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'jpg,jpeg,png,webp',
              max_file_size: 2048,
              equation: ':project_id.image',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 1,
            },
            show_condition: null,
            disable_condition: null,
          },
        ],
      },
      {
        name: 'Project Brief Information',
        show_condition: ":project_id.type_slug === 'project-related-to-fund'",
        updated_field_keys: [],
        fields: [
          {
            type: 'drop_down_menu',
            key: 'allowed_delivery_methods',
            label: 'Allowed Delivery Methods',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Allowed Delivery Methods',
              options: [
                {
                  value: 'dbb',
                  label: 'Design-Bid-Build Method',
                },
                {
                  value: 'db',
                  label: 'Design-Build Method',
                },
                {
                  value: 'epc',
                  label: 'Engineering-Procurement-Construction (Turnkey)',
                },
                {
                  value: 'cmar',
                  label: 'Construction Management at Risk',
                },
                {
                  value: 'cma',
                  label: 'Construction Management Agency',
                },
                {
                  value: 'bot',
                  label: 'Build-Operate-Transfer',
                },
                {
                  value: 'jv',
                  label: 'Joint Venture Contract Method',
                },
                {
                  value: 'ipd',
                  label: 'Integrated Project Delivery Method',
                },
                {
                  value: 'dl',
                  label: 'Direct Labor Method',
                },
                {
                  value: 'sc',
                  label: 'Separate Contracts Method',
                },
              ],
              equation: ':project_id.brief.allowed_delivery_methods',
            },
            can_answered: true,
            can_edit: true,
            is_required: true,
            multiple: {
              min_size: 1,
              max_size: null,
            },
            show_condition:
              ":project_id.type_slug === 'project-related-to-fund'",
            disable_condition: null,
          },
          {
            type: 'money',
            key: 'maximum_allowed_budget',
            label: 'Maximum Allowed Budget',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Maximum Allowed Budget',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.brief.maximum_allowed_budget',
            },
            can_answered: true,
            can_edit: true,
            is_required: true,
            multiple: null,
            show_condition:
              ":project_id.type_slug === 'project-related-to-fund'",
            disable_condition: null,
          },
          {
            type: 'date_picker',
            key: 'maximum_allowed_at',
            label: 'Maximum Allowed End Date',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Maximum Allowed End Date',
              equation: ':project_id.brief.maximum_allowed_at',
            },
            can_answered: true,
            can_edit: true,
            is_required: true,
            multiple: null,
            show_condition:
              ":project_id.type_slug === 'project-related-to-fund'",
            disable_condition: null,
          },
          {
            type: 'drop_down_menu',
            key: 'allowed_tendering_methods',
            label: 'Allowed Tendering Methods',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Allowed Tendering Methods',
              options: [
                {
                  value: 'open_tendering',
                  label: 'Open Tendering',
                },
                {
                  value: 'close_tendering',
                  label: 'Close Tendering',
                },
                {
                  value: 'serial_tendering',
                  label: 'Serial Tendering',
                },
                {
                  value: 'force_tendering',
                  label: 'Force Tendering',
                },
              ],
              equation: ':project_id.brief.allowed_tendering_methods',
            },
            can_answered: true,
            can_edit: true,
            is_required: true,
            multiple: {
              min_size: 1,
              max_size: null,
            },
            show_condition:
              ":project_id.type_slug === 'project-related-to-fund'",
            disable_condition: null,
          },
          {
            type: 'media',
            key: 'attachments',
            label: 'Attachments',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,rar,zip',
              max_file_size: 25600,
              equation: ':project_id.brief.attachments',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 10,
            },
            show_condition:
              ":project_id.type_slug === 'project-related-to-fund'",
            disable_condition: null,
          },
          {
            type: 'table',
            key: 'brief_classifications_types',
            label: 'Contract Classifications and Types',
            properties: {
              min: 1,
              max: 0,
              current_length: 0,
              equation: ':project_id.brief.contract_classifications_and_types',
              can_maintain_items: true,
            },
            can_answered: true,
            can_edit: true,
            is_required: true,
            show_condition:
              ":project_id.type_slug === 'project-related-to-fund'",
            fields: [
              {
                type: 'lookup-simple',
                key: 'contract_classification_id',
                label: 'Contract Classification',
                tooltip: null,
                value: null,
                properties: {
                  options: {
                    api: 'https://dib.api.dev.kuiper.areebholding.work/api/v1/lookup/contract-classifications?tenant=dib&access_throw=workflow',
                    filters: [
                      {
                        key: 'is_in_blocking_states',
                        value: '0',
                        value_type: 'static',
                        multiple: false,
                        required: true,
                      },
                      {
                        key: 'not_ids',
                        value: 'contract_classification_id',
                        value_type: 'dynamic',
                        multiple: true,
                        required: false,
                      },
                    ],
                    keys: {
                      label: 'label',
                      value: 'value',
                      icon: null,
                      tag: null,
                      hint: 'hint',
                      extraLabels: [],
                    },
                  },
                  on_select_data: [],
                  equation: ':contract_classification',
                },
                can_answered: true,
                can_edit: true,
                is_required: true,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
              {
                type: 'lookup-simple',
                key: 'contract_type_ids',
                label: 'Contract Types',
                tooltip: null,
                value: null,
                properties: {
                  options: {
                    api: 'https://dib.api.dev.kuiper.areebholding.work/api/v1/lookup/contract-types?tenant=dib&access_throw=workflow',
                    filters: [
                      {
                        key: 'is_in_blocking_states',
                        value: '0',
                        value_type: 'static',
                        multiple: false,
                        required: true,
                      },
                      {
                        key: 'classification.id',
                        value: 'contract_classification_id',
                        value_type: 'dynamic',
                        multiple: false,
                        required: true,
                      },
                      {
                        key: 'not_ids',
                        value: 'contract_type_ids',
                        value_type: 'dynamic',
                        multiple: true,
                        required: false,
                      },
                    ],
                    keys: {
                      label: 'label',
                      value: 'value',
                      icon: null,
                      tag: null,
                      hint: 'hint',
                      extraLabels: [],
                    },
                  },
                  on_select_data: [],
                  equation: ':contract_types',
                },
                can_answered: true,
                can_edit: true,
                is_required: true,
                multiple: {
                  min_size: 1,
                  max_size: null,
                },
                show_condition: null,
                disable_condition:
                  ':contract_classification_id.should_add_type == "false"',
              },
            ],
          },
        ],
      },
      {
        name: 'Entity Roles',
        show_condition: null,
        updated_field_keys: [],
        fields: [
          {
            type: 'form',
            key: 'roles',
            label: 'Roles',
            properties: {
              min: 0,
              max: 22,
              current_length: 0,
              equation: ':project_id.roles',
              can_maintain_items: true,
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            show_condition: null,
            fields: [
              {
                type: 'lookup-simple',
                key: 'role_id',
                label: 'Role',
                tooltip: null,
                value: null,
                properties: {
                  options: {
                    api: 'https://dib.api.dev.kuiper.areebholding.work/api/v1/lookup/project-roles?tenant=dib&access_throw=workflow',
                    filters: [
                      {
                        key: 'is_in_blocking_states',
                        value: '0',
                        value_type: 'static',
                        multiple: false,
                        required: true,
                      },
                      {
                        key: 'not_ids',
                        value: 'role_id',
                        value_type: 'dynamic',
                        multiple: true,
                        required: true,
                      },
                    ],
                    keys: {
                      label: 'label',
                      value: 'value',
                      icon: null,
                      tag: null,
                      hint: 'hint',
                      extraLabels: [],
                    },
                  },
                  on_select_data: [],
                  equation: ':role',
                },
                can_answered: true,
                can_edit: true,
                is_required: true,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
              {
                type: 'lookup-simple',
                key: 'user_id',
                label: 'User',
                tooltip: null,
                value: null,
                properties: {
                  options: {
                    api: 'https://dib.api.dev.kuiper.areebholding.work/api/v1/lookup/users?tenant=dib&access_throw=workflow',
                    filters: [
                      {
                        key: 'is_in_blocking_states',
                        value: '0',
                        value_type: 'static',
                        multiple: false,
                        required: true,
                      },
                      {
                        key: 'not_state',
                        value: 'inactive',
                        value_type: 'static',
                        multiple: false,
                        required: true,
                      },
                    ],
                    keys: {
                      label: 'label',
                      value: 'value',
                      icon: 'image',
                      tag: null,
                      hint: 'hint',
                      extraLabels: [],
                    },
                  },
                  on_select_data: [],
                  equation: ':resource_data',
                },
                can_answered: true,
                can_edit: true,
                is_required: true,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
            ],
          },
        ],
      },
      {
        name: 'Fund Summary Specification',
        show_condition: ":project_id.type_slug === 'fund'",
        updated_field_keys: [],
        fields: [
          {
            type: 'dual_language_rich_text',
            key: 'entity_overview',
            label: 'Entity Overview',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Entity Overview',
              equation: ':project_id.fund.translations.overview',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'lookup-simple',
            key: 'fund_type_option_id',
            label: 'Fund Type',
            tooltip: null,
            value: null,
            properties: {
              options: {
                api: 'https://dib.api.dev.kuiper.areebholding.work/api/v1/lookup/variable-options?tenant=dib&access_throw=workflow',
                filters: [
                  {
                    key: 'is_in_blocking_states',
                    value: '0',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                  {
                    key: 'variable.key',
                    value: 'fund_type',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                  {
                    key: 'variable.module',
                    value: 'project',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                  {
                    key: 'is_active',
                    value: '1',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                ],
                keys: {
                  label: 'label',
                  value: 'value',
                  icon: null,
                  tag: null,
                  hint: 'hint',
                  extraLabels: [],
                },
              },
              on_select_data: [],
              equation: ':project_id.fund.type',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'short_text_field',
            key: 'fund_cma_id',
            label: 'Fund CMA ID',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Fund CMA ID',
              equation: ':project_id.fund.cma_id',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'dual_language_text',
            key: 'spv_name',
            label: 'SPV Name',
            tooltip: null,
            value: null,
            properties: {
              equation: ':project_id.fund.translations.spv_name',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'number_input_field',
            key: 'unified_number',
            label: 'Unified Number',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Unified Number',
              min_decimal_places: 0,
              max_decimal_places: 0,
              equation: ':project_id.fund.unified_number',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'number_input_field',
            key: 'vat_number',
            label: 'VAT Number',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'VAT Number',
              min_decimal_places: 0,
              max_decimal_places: 0,
              equation: ':project_id.fund.vat_number',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'lookup-simple',
            key: 'vat_refund_mechanism',
            label: 'VAT Refund Mechanism',
            tooltip: null,
            value: null,
            properties: {
              options: {
                api: 'https://dib.api.dev.kuiper.areebholding.work/api/v1/lookup/variable-options?tenant=dib&access_throw=workflow',
                filters: [
                  {
                    key: 'is_in_blocking_states',
                    value: '0',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                  {
                    key: 'variable.key',
                    value: 'vat_refund_mechanism',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                  {
                    key: 'variable.module',
                    value: 'project',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                  {
                    key: 'is_active',
                    value: '1',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                ],
                keys: {
                  label: 'label',
                  value: 'value',
                  icon: null,
                  tag: null,
                  hint: 'hint',
                  extraLabels: [],
                },
              },
              on_select_data: [],
              equation: ':project_id.fund.vat_refund_mechanism',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'number_input_field',
            key: 'commercial_registration_number_custodian_company',
            label: 'Commercial Registration Number of the Custodian Company',
            tooltip: null,
            value: null,
            properties: {
              placeholder:
                'Commercial Registration Number of the Custodian Company',
              min_decimal_places: 0,
              max_decimal_places: 0,
              equation: ':project_id.fund.commercial_registration_number',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'money',
            key: 'fund_capital',
            label: ' Paid Up Capital',
            tooltip: null,
            value: null,
            properties: {
              placeholder: ' Paid Up Capital',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.fund.paid_up_capital',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'money',
            key: 'fund_targeted_capital',
            label: ' Fund Targeted Capital',
            tooltip: null,
            value: null,
            properties: {
              placeholder: ' Fund Targeted Capital',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.fund.fund_targeted_capital',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'money',
            key: 'required_funding',
            label: 'Required Funding',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Required Funding',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.fund.required_funding',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'lookup',
            key: 'developer_id',
            label: 'Developer',
            tooltip: null,
            value: null,
            properties: {
              options: {
                api: 'https://dib.api.dev.kuiper.areebholding.work/api/v1/lookup/vendors?tenant=dib&access_throw=workflow',
                filters: [
                  {
                    key: 'is_in_blocking_states',
                    value: '0',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                  {
                    key: 'state',
                    value: 'qualified',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                  {
                    key: 'search',
                    value: null,
                    value_type: 'search',
                    multiple: false,
                    required: false,
                  },
                ],
                keys: {
                  label: 'label',
                  value: 'value',
                  icon: 'image',
                  tag: 'state',
                  hint: 'hint',
                  extraLabels: [
                    {
                      label: 'Vendor Category',
                      key: 'category_name',
                    },
                    {
                      label: 'Vendor Sub Category',
                      key: 'sub_category_name',
                    },
                  ],
                },
              },
              on_select_data: [],
              equation: ':project_id.fund.developer',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'dual_language_text',
            key: 'contractor_name',
            label: 'Contractor Name',
            tooltip: null,
            value: null,
            properties: {
              equation: ':project_id.fund.translations.contractor_name',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'lookup-simple',
            key: 'purpose_of_fund_development_type',
            label: 'Purpose of the Fund - Development Type',
            tooltip: null,
            value: null,
            properties: {
              options: {
                api: 'https://dib.api.dev.kuiper.areebholding.work/api/v1/lookup/variable-options?tenant=dib&access_throw=workflow',
                filters: [
                  {
                    key: 'is_in_blocking_states',
                    value: '0',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                  {
                    key: 'variable.key',
                    value: 'fund_development_purpose',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                  {
                    key: 'variable.module',
                    value: 'project',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                  {
                    key: 'is_active',
                    value: '1',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                ],
                keys: {
                  label: 'label',
                  value: 'value',
                  icon: null,
                  tag: null,
                  hint: 'hint',
                  extraLabels: [],
                },
              },
              on_select_data: [],
              equation: ':project_id.fund.development_purpose',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'short_text_field',
            key: 'developer_reimbursement_qualifications_number',
            label: 'Developer Reimbursement Qualifications Number',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Developer Reimbursement Qualifications Number',
              equation:
                ':project_id.fund.developer_reimbursement_qualifications_number',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'number_input_field',
            key: 'expected_return_on_investors_capital_roe',
            label: "Expected Return on Investor's Capital (ROE)",
            tooltip: null,
            value: null,
            properties: {
              placeholder: "Expected Return on Investor's Capital (ROE)",
              min_decimal_places: 0,
              max_decimal_places: 2,
              formatType: 'percentage',
              equation:
                ':project_id.fund.expected_return_on_investment_capital',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'dual_language_text',
            key: 'main_investor',
            label: 'Main Investor',
            tooltip: null,
            value: null,
            properties: {
              equation: ':project_id.fund.translations.main_investor',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'dual_language_text',
            key: 'financial_auditor_name',
            label: 'Financial Auditor Name',
            tooltip: null,
            value: null,
            properties: {
              equation: ':project_id.fund.translations.financial_auditor_name',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
        ],
      },
      {
        name: 'Project Definition',
        show_condition: ":project_id.type_slug === 'project-related-to-fund'",
        updated_field_keys: [],
        fields: [
          {
            type: 'dual_language_rich_text',
            key: 'definition_description',
            label: 'Project Description',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Project Description',
              equation: ':project_id.definition.translations.description',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition:
              ":project_id.type_slug === 'project-related-to-fund'",
            disable_condition: null,
          },
          {
            type: 'dual_language_rich_text',
            key: 'definition_employer_requirements',
            label: 'Employer Requirements',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Employer Requirements',
              equation:
                ':project_id.definition.translations.employer_requirements',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition:
              ":project_id.type_slug === 'project-related-to-fund'",
            disable_condition: null,
          },
          {
            type: 'dual_language_rich_text',
            key: 'definition_space_program',
            label: 'Space Program',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Space Program',
              equation: ':project_id.definition.translations.space_program',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition:
              ":project_id.type_slug === 'project-related-to-fund'",
            disable_condition: null,
          },
          {
            type: 'dual_language_rich_text',
            key: 'definition_project_scope',
            label: 'Project Scope',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Project Scope',
              equation: ':project_id.definition.translations.project_scope',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition:
              ":project_id.type_slug === 'project-related-to-fund'",
            disable_condition: null,
          },
          {
            type: 'dual_language_rich_text',
            key: 'definition_exclusions',
            label: 'Exclusions',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Exclusions',
              equation: ':project_id.definition.translations.exclusions',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition:
              ":project_id.type_slug === 'project-related-to-fund'",
            disable_condition: null,
          },
          {
            type: 'dual_language_rich_text',
            key: 'definition_targeted_users',
            label: 'Targeted Users',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Targeted Users',
              equation: ':project_id.definition.translations.targeted_users',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition:
              ":project_id.type_slug === 'project-related-to-fund'",
            disable_condition: null,
          },
          {
            type: 'dual_language_rich_text',
            key: 'definition_benefit_goals',
            label: 'Benefit Goals',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Benefit Goals',
              equation: ':project_id.definition.translations.benefit_goals',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition:
              ":project_id.type_slug === 'project-related-to-fund'",
            disable_condition: null,
          },
          {
            type: 'dual_language_rich_text',
            key: 'definition_constrains',
            label: 'Constraints',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Constraints',
              equation: ':project_id.definition.translations.constrains',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition:
              ":project_id.type_slug === 'project-related-to-fund'",
            disable_condition: null,
          },
          {
            type: 'dual_language_rich_text',
            key: 'definition_project_risk',
            label: 'Project Risk',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Project Risk',
              equation: ':project_id.definition.translations.project_risk',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition:
              ":project_id.type_slug === 'project-related-to-fund'",
            disable_condition: null,
          },
          {
            type: 'dual_language_rich_text',
            key: 'definition_project_tolerance',
            label: 'Project Tolerance',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Project Tolerance',
              equation: ':project_id.definition.translations.project_tolerance',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition:
              ":project_id.type_slug === 'project-related-to-fund'",
            disable_condition: null,
          },
        ],
      },
      {
        name: 'Financial & Purpose',
        show_condition: ":project_id.type_slug === 'fund'",
        updated_field_keys: [],
        fields: [
          {
            type: 'money',
            key: 'fund_value_sar',
            label: 'Fund Value (SAR)',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Fund Value (SAR)',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.fund.value',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'dual_language_rich_text',
            key: 'fund_purpose',
            label: 'Fund Purpose',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Fund Purpose',
              equation: ':project_id.fund.translations.purpose',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'money',
            key: 'unit_nominal_value_sar',
            label: 'Unit Nominal Value (SAR)',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Unit Nominal Value (SAR)',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.fund.unit_nominal_value',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'dual_language_text',
            key: 'fund_risk',
            label: 'Fund Risk',
            tooltip: null,
            value: null,
            properties: {
              equation: ':project_id.fund.translations.risk',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
        ],
      },
      {
        name: 'Bank Account Details',
        show_condition:
          ':project_id.type_slug === \'fund\' || :bank_account_id != "" || :bank_account_id != "" && :bank_account_identifier_type === "iban" || :bank_account_id != "" && :bank_account_identifier_type === "account_number"',
        updated_field_keys: [],
        fields: [
          {
            type: 'lookup',
            key: 'bank_account_id',
            label: 'Bank Account',
            tooltip: null,
            value: null,
            properties: {
              options: {
                api: 'https://dib.api.dev.kuiper.areebholding.work/api/v1/lookup/projects/bank-accounts?tenant=dib&access_throw=workflow',
                filters: [
                  {
                    key: 'is_in_blocking_states',
                    value: '0',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                  {
                    key: 'search',
                    value: null,
                    value_type: 'search',
                    multiple: false,
                    required: false,
                  },
                  {
                    key: 'project_id',
                    value: 'project_id',
                    value_type: 'dynamic',
                    multiple: false,
                    required: true,
                  },
                ],
                keys: {
                  label: 'label',
                  value: 'value',
                  icon: null,
                  tag: null,
                  hint: 'hint',
                  extraLabels: [
                    {
                      label: 'Currency',
                      key: 'currency',
                    },
                    {
                      label: 'IBAN / Account number',
                      key: 'identifier',
                    },
                  ],
                },
              },
              on_select_data: [
                {
                  api: 'https://dib.api.dev.kuiper.areebholding.work/api/v1/application/projects/:project_id/bank-accounts/:bank_account_id?tenant=dib&access_throw=workflow',
                  filters: [],
                  replacement_keys: [
                    {
                      search: 'country.id',
                      replace: 'country.value',
                    },
                    {
                      search: 'country.name',
                      replace: 'country.label',
                    },
                    {
                      search: 'currency.id',
                      replace: 'currency.value',
                    },
                    {
                      search: 'currency.name',
                      replace: 'currency.label',
                    },
                  ],
                  data_type: 'object',
                  data_key: null,
                },
              ],
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'lookup-simple',
            key: 'bank_account_country_id',
            label: 'Bank Country',
            tooltip: null,
            value: null,
            properties: {
              options: {
                api: 'https://dib.api.dev.kuiper.areebholding.work/api/v1/lookup/countries?tenant=dib&access_throw=workflow',
                filters: [
                  {
                    key: 'is_in_blocking_states',
                    value: '0',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                ],
                keys: {
                  label: 'label',
                  value: 'value',
                  icon: null,
                  tag: null,
                  hint: 'hint',
                  extraLabels: [],
                },
              },
              on_select_data: [],
              equation: ':bank_account_id.country',
            },
            can_answered: true,
            can_edit: true,
            is_required: true,
            multiple: null,
            show_condition: ':bank_account_id != ""',
            disable_condition: null,
          },
          {
            type: 'dual_language_text',
            key: 'bank_account_bank_name',
            label: 'Bank Name',
            tooltip: null,
            value: null,
            properties: {
              equation: ':bank_account_id.translations.bank_name',
            },
            can_answered: true,
            can_edit: true,
            is_required: true,
            multiple: null,
            show_condition: ':bank_account_id != ""',
            disable_condition: null,
          },
          {
            type: 'lookup-simple',
            key: 'bank_account_currency_id',
            label: 'Account Currency',
            tooltip: null,
            value: null,
            properties: {
              options: {
                api: 'https://dib.api.dev.kuiper.areebholding.work/api/v1/lookup/currencies?tenant=dib&access_throw=workflow',
                filters: [
                  {
                    key: 'is_in_blocking_states',
                    value: '0',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                ],
                keys: {
                  label: 'label',
                  value: 'value',
                  icon: null,
                  tag: null,
                  hint: 'hint',
                  extraLabels: [],
                },
              },
              on_select_data: [],
              equation: ':bank_account_id.currency',
            },
            can_answered: true,
            can_edit: true,
            is_required: true,
            multiple: null,
            show_condition: ':bank_account_id != ""',
            disable_condition: null,
          },
          {
            type: 'radio_button',
            key: 'bank_account_type',
            label: 'Account Type',
            tooltip: null,
            value: null,
            properties: {
              options: [
                {
                  value: 'current',
                  label: 'Current',
                },
                {
                  value: 'wafi',
                  label: 'Wafi',
                },
              ],
              equation: ':bank_account_id.account_type.value',
            },
            can_answered: true,
            can_edit: true,
            is_required: true,
            multiple: null,
            show_condition: ':bank_account_id != ""',
            disable_condition: null,
          },
          {
            type: 'dual_language_text',
            key: 'bank_account_holder_name',
            label: 'Account Holder Name',
            tooltip: null,
            value: null,
            properties: {
              equation: ':bank_account_id.translations.holder_name',
            },
            can_answered: true,
            can_edit: true,
            is_required: true,
            multiple: null,
            show_condition: ':bank_account_id != ""',
            disable_condition: null,
          },
          {
            type: 'radio_button',
            key: 'bank_account_identifier_type',
            label: 'Account Details',
            tooltip: null,
            value: null,
            properties: {
              options: [
                {
                  value: 'iban',
                  label: 'IBAN',
                },
                {
                  value: 'account_number',
                  label: 'Account Number',
                },
              ],
              equation: ':bank_account_id.identifier_type',
            },
            can_answered: true,
            can_edit: true,
            is_required: true,
            multiple: null,
            show_condition: ':bank_account_id != ""',
            disable_condition: null,
          },
          {
            type: 'short_text_field',
            key: 'bank_account_iban',
            label: 'IBAN',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'IBAN',
              equation: ':bank_account_id.identifier',
            },
            can_answered: true,
            can_edit: true,
            is_required: true,
            multiple: null,
            show_condition:
              ':bank_account_id != "" && :bank_account_identifier_type === "iban"',
            disable_condition: null,
          },
          {
            type: 'short_text_field',
            key: 'bank_account_number',
            label: 'Account Number',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Account Number',
              equation: ':bank_account_id.identifier',
            },
            can_answered: true,
            can_edit: true,
            is_required: true,
            multiple: null,
            show_condition:
              ':bank_account_id != "" && :bank_account_identifier_type === "account_number"',
            disable_condition: null,
          },
          {
            type: 'short_text_field',
            key: 'bank_account_swift_code',
            label: 'Swift Code',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Swift Code',
              equation: ':bank_account_id.swift_code',
            },
            can_answered: true,
            can_edit: true,
            is_required: true,
            multiple: null,
            show_condition:
              ':bank_account_id != "" && :bank_account_identifier_type === "account_number"',
            disable_condition: null,
          },
          {
            type: 'dual_language_rich_text',
            key: 'bank_account_notes',
            label: 'Notes',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Notes',
              equation: ':bank_account_id.translations.notes',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ':bank_account_id != ""',
            disable_condition: null,
          },
          {
            type: 'media',
            key: 'bank_account_certificate_files',
            label: 'Bank Account Certificate Files',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,rar,zip',
              max_file_size: 25600,
              equation: ':bank_account_id.bank_certificate_files',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 2,
            },
            show_condition: ':bank_account_id != ""',
            disable_condition: null,
          },
        ],
      },
      {
        name: 'Fund Date',
        show_condition: ":project_id.type_slug === 'fund'",
        updated_field_keys: [],
        fields: [
          {
            type: 'date_picker',
            key: 'start_date',
            label: 'Start Date',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Start Date',
              equation: ':project_id.fund.start_date',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'date_picker',
            key: 'fund_operation_date',
            label: 'Fund Operation Date',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Fund Operation Date',
              equation: ':project_id.fund.operation_date',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'date_picker',
            key: 'fund_license_date',
            label: 'Fund License Date',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Fund License Date',
              equation: ':project_id.fund.license_date',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'date_picker',
            key: 'offering_period_start_date',
            label: 'Offering Period Start Date',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Offering Period Start Date',
              equation: ':project_id.fund.offering_period_start_date',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'date_picker',
            key: 'offering_period_end_date',
            label: 'Offering Period End Date',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Offering Period End Date',
              equation: ':project_id.fund.offering_period_end_date',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'date_picker',
            key: 'fund_first_year_end_date',
            label: 'Fund First Year End Date',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Fund First Year End Date',
              equation: ':project_id.fund.first_year_end_date',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'date_picker',
            key: 'notice_date',
            label: 'Notice Date',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Notice Date',
              equation: ':project_id.fund.notice_date',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'date_picker',
            key: 'latest_tc_update_date',
            label: 'Latest T&C Update Date',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Latest T&C Update Date',
              equation: ':project_id.fund.latest_tc_update_date',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
        ],
      },
      {
        name: 'Fund Duration',
        show_condition: ":project_id.type_slug === 'fund'",
        updated_field_keys: [],
        fields: [
          {
            type: 'number_input_field',
            key: 'fund_duration_years',
            label: 'Fund Duration (Years)',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Fund Duration (Years)',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.fund.duration',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'number_input_field',
            key: 'duration_extension_years',
            label: 'Duration Extension (Years)',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Duration Extension (Years)',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.fund.duration_extension',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
        ],
      },
      {
        name: 'Fund Investment Strategy',
        show_condition: ":project_id.type_slug === 'fund'",
        updated_field_keys: [],
        fields: [
          {
            type: 'media',
            key: 'last_updated_tc',
            label: 'Last Updated T&C',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,rar,zip',
              max_file_size: 25600,
              equation: ':project_id.fund.last_updated_tc',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 10,
            },
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
        ],
      },
      {
        name: 'Fund Financial Goals',
        show_condition: ":project_id.type_slug === 'fund'",
        updated_field_keys: [],
        fields: [
          {
            type: 'number_input_field',
            key: 'targeted_irr_roi_percentage',
            label: 'Targeted IRR/ROI (Percentage)',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Targeted IRR/ROI (Percentage)',
              min_decimal_places: 0,
              max_decimal_places: 2,
              formatType: 'percentage',
              equation: ':project_id.fund.targeted_irr_percentage',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'lookup-simple',
            key: 'targeted_dividends_type',
            label: 'Targeted Dividents Type',
            tooltip: null,
            value: null,
            properties: {
              options: {
                api: 'https://dib.api.dev.kuiper.areebholding.work/api/v1/lookup/variable-options?tenant=dib&access_throw=workflow',
                filters: [
                  {
                    key: 'is_in_blocking_states',
                    value: '0',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                  {
                    key: 'variable.key',
                    value: 'targeted_dividends_type',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                  {
                    key: 'variable.module',
                    value: 'project',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                  {
                    key: 'is_active',
                    value: '1',
                    value_type: 'static',
                    multiple: false,
                    required: true,
                  },
                ],
                keys: {
                  label: 'label',
                  value: 'value',
                  icon: null,
                  tag: null,
                  hint: 'hint',
                  extraLabels: [],
                },
              },
              on_select_data: [],
              equation: ':project_id.fund.targeted_dividends_type_option',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'number_input_field',
            key: 'targeted_dividends_percentage',
            label: 'Targeted Dividents (Percentage)',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Targeted Dividents (Percentage)',
              min_decimal_places: 0,
              max_decimal_places: 2,
              formatType: 'percentage',
              equation: ':project_id.fund.targeted_dividends_percentage',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'money',
            key: 'targeted_dividends_value',
            label: 'Targeted Dividents Value',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Targeted Dividents Value',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.fund.targeted_dividends_value',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
        ],
      },
      {
        name: 'Opportunity Info Specification',
        show_condition: ":project_id.type_slug === 'fund'",
        updated_field_keys: [],
        fields: [
          {
            type: 'dual_language_text',
            key: 'location',
            label: 'Location',
            tooltip: null,
            value: null,
            properties: {
              equation: ':project_id.fund.translations.location',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'number_input_field',
            key: 'land_size',
            label: ' Land Size (m²)',
            tooltip: null,
            value: null,
            properties: {
              placeholder: ' Land Size (m²) ',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.fund.land_size',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'money',
            key: 'land_acquisition_price',
            label: 'Land Acquisition Price',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Land Acquisition Price',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.fund.land_acquisition_price',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'money',
            key: 'expected_land_valuation',
            label: 'Expected Land Valuation',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Expected Land Valuation',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.fund.expected_land_valuation',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'money',
            key: 'development_costs',
            label: 'Development Costs',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Development Costs',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.fund.development_cost',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'money',
            key: 'total_project_cost',
            label: 'Total Project Cost',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Total Project Cost',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.fund.total_project_cost',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
        ],
      },
      {
        name: 'Fund Structure Specification',
        show_condition: ":project_id.type_slug === 'fund'",
        updated_field_keys: [],
        fields: [
          {
            type: 'number_input_field',
            key: 'equity_ownership_percentage',
            label: 'Equity Ownership Percentage (%)',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Equity Ownership Percentage (%)',
              min_decimal_places: 0,
              max_decimal_places: 2,
              formatType: 'percentage',
              equation: ':project_id.fund.equity_ownership_percentage',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'number_input_field',
            key: 'financing_percentage',
            label: 'Financing Percentage (%)',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Financing Percentage (%)',
              min_decimal_places: 0,
              max_decimal_places: 2,
              formatType: 'percentage',
              equation: ':project_id.fund.financing_percentage',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
        ],
      },
      {
        name: 'Fund Fees Specification',
        show_condition: ":project_id.type_slug === 'fund'",
        updated_field_keys: [],
        fields: [
          {
            type: 'composite',
            key: 'structuring',
            label: 'Structuring Fees',
            properties: {
              min: 0,
              max: 1,
              current_length: 0,
              equation: ':project_id.fund.structuring',
              can_maintain_items: true,
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            show_condition: null,
            fields: [
              {
                type: 'money',
                key: 'structuring_fees',
                label: 'Structuring Fees',
                tooltip: null,
                value: null,
                properties: {
                  placeholder: 'Structuring Fees',
                  min_decimal_places: 0,
                  max_decimal_places: 2,
                },
                can_answered: true,
                can_edit: true,
                is_required: false,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
              {
                type: 'number_input_field',
                key: 'structuring_fees_percentage',
                label: 'Structuring Fees Percentage',
                tooltip: null,
                value: null,
                properties: {
                  placeholder: 'Percentage',
                  min_decimal_places: 0,
                  max_decimal_places: 2,
                  formatType: 'percentage',
                },
                can_answered: true,
                can_edit: true,
                is_required: false,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
            ],
          },
          {
            type: 'composite',
            key: 'debt_arrangement',
            label: 'Debt Arrangement Fees',
            properties: {
              min: 0,
              max: 1,
              current_length: 0,
              equation: ':project_id.fund.debt_arrangement',
              can_maintain_items: true,
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            show_condition: null,
            fields: [
              {
                type: 'money',
                key: 'debt_arrangement_fees',
                label: 'Debt Arrangement Fees',
                tooltip: null,
                value: null,
                properties: {
                  placeholder: 'Debt Arrangement Fees',
                  min_decimal_places: 0,
                  max_decimal_places: 2,
                  equation:
                    ':project_id.fund.debt_arrangement.0.debt_arrangement_fees',
                },
                can_answered: true,
                can_edit: true,
                is_required: false,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
              {
                type: 'number_input_field',
                key: 'debt_arrangement_fees_percentage',
                label: 'Debt Arrangement Fees Percentage',
                tooltip: null,
                value: null,
                properties: {
                  placeholder: 'Percentage',
                  min_decimal_places: 0,
                  max_decimal_places: 2,
                  formatType: 'percentage',
                  equation:
                    ':project_id.fund.debt_arrangement.0.debt_arrangement_fees_percentage',
                },
                can_answered: true,
                can_edit: true,
                is_required: false,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
            ],
          },
          {
            type: 'composite',
            key: 'subscription',
            label: 'Subscription Fees',
            properties: {
              min: 0,
              max: 1,
              current_length: 0,
              equation: ':project_id.subscription',
              can_maintain_items: true,
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            show_condition: null,
            fields: [
              {
                type: 'money',
                key: 'subscription_fees',
                label: 'Subscription Fees',
                tooltip: null,
                value: null,
                properties: {
                  placeholder: 'Subscription Fees',
                  min_decimal_places: 0,
                  max_decimal_places: 2,
                  equation: ':project_id.fund.subscription.0.subscription_fees',
                },
                can_answered: true,
                can_edit: true,
                is_required: false,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
              {
                type: 'number_input_field',
                key: 'subscription_fees_percentage',
                label: 'Subscription Fees Percentage',
                tooltip: null,
                value: null,
                properties: {
                  placeholder: 'Percentage',
                  min_decimal_places: 0,
                  max_decimal_places: 2,
                  formatType: 'percentage',
                  equation:
                    ':project_id.fund.subscription.0.subscription_fees_percentage',
                },
                can_answered: true,
                can_edit: true,
                is_required: false,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
            ],
          },
          {
            type: 'composite',
            key: 'administration',
            label: 'Administration Fees',
            properties: {
              min: 0,
              max: 1,
              current_length: 0,
              equation: ':project_id.administration',
              can_maintain_items: true,
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            show_condition: null,
            fields: [
              {
                type: 'money',
                key: 'administration_fees',
                label: 'Administration Fees',
                tooltip: null,
                value: null,
                properties: {
                  placeholder: 'Administration Fees',
                  min_decimal_places: 0,
                  max_decimal_places: 2,
                  equation:
                    ':project_id.fund.administration.0.administration_fees',
                },
                can_answered: true,
                can_edit: true,
                is_required: false,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
              {
                type: 'number_input_field',
                key: 'administration_fees_percentage',
                label: 'Administration Fees Percentage',
                tooltip: null,
                value: null,
                properties: {
                  placeholder: 'Percentage',
                  min_decimal_places: 0,
                  max_decimal_places: 2,
                  formatType: 'percentage',
                  equation:
                    ':project_id.fund.administration.0.administration_fees_percentage',
                },
                can_answered: true,
                can_edit: true,
                is_required: false,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
            ],
          },
          {
            type: 'composite',
            key: 'performance',
            label: 'Performance Fees',
            properties: {
              min: 0,
              max: 1,
              current_length: 0,
              equation: ':project_id.performance',
              can_maintain_items: true,
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            show_condition: null,
            fields: [
              {
                type: 'money',
                key: 'performance_fees',
                label: 'Performance Fees',
                tooltip: null,
                value: null,
                properties: {
                  placeholder: 'Performance Fees',
                  min_decimal_places: 0,
                  max_decimal_places: 2,
                  equation: ':project_id.fund.performance.0.performance_fees',
                },
                can_answered: true,
                can_edit: true,
                is_required: false,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
              {
                type: 'number_input_field',
                key: 'performance_fees_percentage',
                label: 'Performance Fees Percentage',
                tooltip: null,
                value: null,
                properties: {
                  placeholder: 'Percentage',
                  min_decimal_places: 0,
                  max_decimal_places: 2,
                  formatType: 'percentage',
                  equation:
                    ':project_id.fund.performance.0.performance_fees_percentage',
                },
                can_answered: true,
                can_edit: true,
                is_required: false,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
            ],
          },
          {
            type: 'composite',
            key: 'operation',
            label: 'Operation Fees',
            properties: {
              min: 0,
              max: 1,
              current_length: 0,
              equation: ':project_id.operation',
              can_maintain_items: true,
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            show_condition: null,
            fields: [
              {
                type: 'money',
                key: 'operation_fees',
                label: 'Operation Fees',
                tooltip: null,
                value: null,
                properties: {
                  placeholder: 'Operation Fees',
                  min_decimal_places: 0,
                  max_decimal_places: 2,
                  equation: ':project_id.fund.operation.0.operation_fees',
                },
                can_answered: true,
                can_edit: true,
                is_required: false,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
              {
                type: 'number_input_field',
                key: 'operation_fees_percentage',
                label: 'Operation Fees Percentage',
                tooltip: null,
                value: null,
                properties: {
                  placeholder: 'Percentage',
                  min_decimal_places: 0,
                  max_decimal_places: 2,
                  formatType: 'percentage',
                  equation:
                    ':project_id.fund.operation.0.operation_fees_percentage',
                },
                can_answered: true,
                can_edit: true,
                is_required: false,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
            ],
          },
          {
            type: 'money',
            key: 'deal_source',
            label: 'Deal Source',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Deal Source',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.fund.deal_source',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'composite',
            key: 'exit',
            label: 'Exit Fees',
            properties: {
              min: 0,
              max: 1,
              current_length: 0,
              equation: ':project_id.exit',
              can_maintain_items: true,
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            show_condition: null,
            fields: [
              {
                type: 'money',
                key: 'exit_fees',
                label: 'Exit Fees',
                tooltip: null,
                value: null,
                properties: {
                  placeholder: 'Exit Fees',
                  min_decimal_places: 0,
                  max_decimal_places: 2,
                  equation: ':project_id.fund.exit.0.exit_fees',
                },
                can_answered: true,
                can_edit: true,
                is_required: false,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
              {
                type: 'number_input_field',
                key: 'exit_fees_percentage',
                label: 'Exit Fees Percentage',
                tooltip: null,
                value: null,
                properties: {
                  placeholder: 'Percentage',
                  min_decimal_places: 0,
                  max_decimal_places: 2,
                  formatType: 'percentage',
                  equation: ':project_id.fund.exit.0.exit_fees_percentage',
                },
                can_answered: true,
                can_edit: true,
                is_required: false,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
            ],
          },
          {
            type: 'composite',
            key: 'development',
            label: 'Development Fees',
            properties: {
              min: 0,
              max: 1,
              current_length: 0,
              equation: ':project_id.development',
              can_maintain_items: true,
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            show_condition: null,
            fields: [
              {
                type: 'money',
                key: 'development_fees',
                label: 'Development Fees',
                tooltip: null,
                value: null,
                properties: {
                  placeholder: 'Development Fees',
                  min_decimal_places: 0,
                  max_decimal_places: 2,
                  equation: ':project_id.fund.development.0.development_fees',
                },
                can_answered: true,
                can_edit: true,
                is_required: false,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
              {
                type: 'number_input_field',
                key: 'development_fees_percentage',
                label: 'Development Fees Percentage',
                tooltip: null,
                value: null,
                properties: {
                  placeholder: 'Percentage',
                  min_decimal_places: 0,
                  max_decimal_places: 2,
                  formatType: 'percentage',
                  equation:
                    ':project_id.fund.development.0.development_fees_percentage',
                },
                can_answered: true,
                can_edit: true,
                is_required: false,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
            ],
          },
          {
            type: 'composite',
            key: 'total',
            label: 'Total Fees',
            properties: {
              min: 0,
              max: 1,
              current_length: 0,
              equation: ':project_id.total',
              can_maintain_items: true,
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            show_condition: null,
            fields: [
              {
                type: 'money',
                key: 'total_fees',
                label: 'Total Fees',
                tooltip: null,
                value: null,
                properties: {
                  placeholder: 'Total Fees',
                  min_decimal_places: 0,
                  max_decimal_places: 2,
                  equation: ':project_id.fund.total.0.total_fees',
                },
                can_answered: true,
                can_edit: true,
                is_required: false,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
              {
                type: 'number_input_field',
                key: 'total_fees_percentage',
                label: 'Total Fees Percentage',
                tooltip: null,
                value: null,
                properties: {
                  placeholder: 'Percentage',
                  min_decimal_places: 0,
                  max_decimal_places: 2,
                  formatType: 'percentage',
                  equation: ':project_id.fund.total.0.total_fees_percentage',
                },
                can_answered: true,
                can_edit: true,
                is_required: false,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
            ],
          },
          {
            type: 'composite',
            key: 'other',
            label: 'Other Fees',
            properties: {
              min: 0,
              max: 1,
              current_length: 0,
              equation: ':project_id.other',
              can_maintain_items: true,
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            show_condition: null,
            fields: [
              {
                type: 'money',
                key: 'other_fees',
                label: 'Other Fees',
                tooltip: null,
                value: null,
                properties: {
                  placeholder: 'Other Fees',
                  min_decimal_places: 0,
                  max_decimal_places: 2,
                  equation: ':project_id.fund.other.0.other_fees',
                },
                can_answered: true,
                can_edit: true,
                is_required: false,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
              {
                type: 'number_input_field',
                key: 'other_fees_percentage',
                label: 'Other Fees Percentage',
                tooltip: null,
                value: null,
                properties: {
                  placeholder: 'Percentage',
                  min_decimal_places: 0,
                  max_decimal_places: 2,
                  formatType: 'percentage',
                  equation: ':project_id.fund.other.0.other_fees_percentage',
                },
                can_answered: true,
                can_edit: true,
                is_required: false,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
            ],
          },
          {
            type: 'date_picker',
            key: 'management_fees_calculation_start_date',
            label: 'Management Fees Calculation Start Date',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Management Fees Calculation Start Date',
              equation:
                ':project_id.fund.management_fees_calculation_start_date',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'date_picker',
            key: 'management_fees_calculation_end_date',
            label: 'Management Fees Calculation End Date',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Management Fees Calculation End Date',
              equation: ':project_id.fund.management_fees_calculation_end_date',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
        ],
      },
      {
        name: 'Cost Benefit Analysis Specification',
        show_condition: ":project_id.type_slug === 'fund'",
        updated_field_keys: [],
        fields: [
          {
            type: 'money',
            key: 'direct_costs',
            label: 'Direct Costs',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Direct Costs',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.fund.direct_costs',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'money',
            key: 'indirect_costs',
            label: 'Indirect Costs',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Indirect Costs',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.fund.indirect_costs',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'money',
            key: 'unassessed_costs',
            label: 'Unassessed Costs',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Unassessed Costs',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.fund.unassigned_costs',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'money',
            key: 'opportunity_costs',
            label: 'Opportunity Costs',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Opportunity Costs',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.fund.opportunity_costs',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'money',
            key: 'potential_risk_costs',
            label: 'Potential Risk Costs',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Potential Risk Costs',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.fund.potential_risk_costs',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'money',
            key: 'fund_operational_load',
            label: 'Fund Operational Load',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Fund Operational Load',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.fund.operational_load',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'drop_down_menu',
            key: 'requirements_fund_operation',
            label: 'Requirements / Fund Operation',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Requirements / Fund Operation',
              options: [
                {
                  value: 'high',
                  label: 'High',
                },
                {
                  value: 'medium',
                  label: 'Medium',
                },
                {
                  value: 'low',
                  label: 'Low',
                },
              ],
              equation: ':project_id.fund.requirements_fund_operation',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
        ],
      },
      {
        name: "Requirements of Land's Documents Verification Specification",
        show_condition: ":project_id.type_slug === 'fund'",
        updated_field_keys: [],
        fields: [
          {
            type: 'media',
            key: 'verification_documents',
            label: 'Verification Documents',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,rar,zip',
              max_file_size: 25600,
              equation: ':project_id.fund.verification_documents',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 10,
            },
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'media',
            key: 'ownership_title_deed',
            label: 'Ownership Title Deed',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,rar,zip',
              max_file_size: 25600,
              equation: ':project_id.fund.ownership_title_deed',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 10,
            },
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'media',
            key: 'power_of_attorney',
            label: 'Power of Attorney',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,rar,zip',
              max_file_size: 25600,
              equation: ':project_id.fund.power_of_attorney',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 10,
            },
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
        ],
      },
      {
        name: 'Infrastructure Development Specification',
        show_condition: ":project_id.type_slug === 'fund'",
        updated_field_keys: [],
        fields: [
          {
            type: 'media',
            key: 'municipal_zoning_map',
            label: 'Municipal Zoning Map',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,rar,zip',
              max_file_size: 25600,
              equation: ':project_id.fund.municipal_zoning_map',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 10,
            },
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'media',
            key: 'approved_site_plan',
            label: 'Approved Site Plan',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,rar,zip',
              max_file_size: 25600,
              equation: ':project_id.fund.approved_site_plan',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 10,
            },
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
        ],
      },
      {
        name: 'Superstructure Development Specification',
        show_condition: ":project_id.type_slug === 'fund'",
        updated_field_keys: [],
        fields: [
          {
            type: 'media',
            key: 'construction_license',
            label: 'Construction License',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,rar,zip',
              max_file_size: 25600,
              equation: ':project_id.fund.construction_license',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 10,
            },
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
        ],
      },
      {
        name: 'Second Party Requirements/Client (Legal Documents) Specification',
        show_condition: ":project_id.type_slug === 'fund'",
        updated_field_keys: [],
        fields: [
          {
            type: 'media',
            key: 'memorandum_of_association',
            label: 'Memorandum of Association',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,rar,zip',
              max_file_size: 25600,
              equation: ':project_id.fund.memorandum_of_association',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 10,
            },
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'media',
            key: 'commercial_registration',
            label: 'Commercial Registration',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,rar,zip',
              max_file_size: 25600,
              equation: ':project_id.fund.commercial_registration',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 10,
            },
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'media',
            key: 'national_id_residency',
            label: 'National ID / Residency',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,rar,zip',
              max_file_size: 25600,
              equation: ':project_id.fund.national_id_residency',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 10,
            },
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
          {
            type: 'media',
            key: 'power_of_attorney_second',
            label: 'Second Party Power of Attorney',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,rar,zip',
              max_file_size: 25600,
              equation: ':project_id.fund.power_of_attorney_second',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 10,
            },
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
        ],
      },
      {
        name: 'Attach Other Documents',
        show_condition: ":project_id.type_slug === 'fund'",
        updated_field_keys: [],
        fields: [
          {
            type: 'media',
            key: 'other_documents',
            label: 'Other Documents',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,rar,zip',
              max_file_size: 25600,
              equation: ':project_id.fund.other_documents',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 10,
            },
            show_condition: ":project_id.type_slug === 'fund'",
            disable_condition: null,
          },
        ],
      },
      {
        name: 'Opportunity Basic Info',
        show_condition: ":project_id.type_slug === 'opportunity'",
        updated_field_keys: [],
        fields: [
          {
            type: 'dual_language_rich_text',
            key: 'opportunity_overview',
            label: 'Opportunity Overview',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Opportunity Overview',
              equation: ':project_id.opportunity.translations.overview',
            },
            can_answered: true,
            can_edit: true,
            is_required: true,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'money',
            key: 'opportunity_capital',
            label: 'Opportunity Capital',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Opportunity Capital',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.opportunity.capital',
            },
            can_answered: true,
            can_edit: true,
            is_required: true,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'money',
            key: 'opportunity_required_funding',
            label: 'Required Funding',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Required Funding',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.opportunity.required_funding',
            },
            can_answered: true,
            can_edit: true,
            is_required: true,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'dual_language_text',
            key: 'opportunity_referral_by_name',
            label: 'Referral by - name',
            tooltip: null,
            value: null,
            properties: {
              equation: ':project_id.opportunity.translations.referral_by_name',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'number_input_field',
            key: 'opportunity_referral_by_id',
            label: 'Referral by - id',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Referral by - id',
              min_decimal_places: 0,
              max_decimal_places: 0,
              equation: ':project_id.opportunity.referral_by_id',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'dual_language_text',
            key: 'opportunity_developer_name',
            label: 'Suggested Developer Name',
            tooltip: null,
            value: null,
            properties: {
              equation: ':project_id.opportunity.translations.developer_name',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'dual_language_text',
            key: 'opportunity_contractor_name',
            label: 'Suggested Contractor Name',
            tooltip: null,
            value: null,
            properties: {
              equation: ':project_id.opportunity.translations.contractor_name',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'number_input_field',
            key: 'opportunity_development_duration',
            label: 'Project Development duration/"door-to-door"',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Project Development duration/"door-to-door"',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.opportunity.duration',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'number_input_field',
            key: 'opportunity_expected_return_on_investors_capital_roe',
            label: "Expected Return on Investor's Capital (ROE)",
            tooltip: null,
            value: null,
            properties: {
              placeholder: "Expected Return on Investor's Capital (ROE)",
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation:
                ':project_id.opportunity.expected_return_on_investment_capital',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'dual_language_text',
            key: 'opportunity_main_investor',
            label: 'Main Investor',
            tooltip: null,
            value: null,
            properties: {
              equation: ':project_id.opportunity.translations.main_investor',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
        ],
      },
      {
        name: 'Opportunity Information Specification',
        show_condition: ":project_id.type_slug === 'opportunity'",
        updated_field_keys: [],
        fields: [
          {
            type: 'dual_language_text',
            key: 'opportunity_location',
            label: 'Location',
            tooltip: null,
            value: null,
            properties: {
              equation: ':project_id.opportunity.translations.location',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'number_input_field',
            key: 'opportunity_area_size',
            label: 'Property Area Per Square Meters',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Property Area Per Square Meters',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.opportunity.area_size',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'money',
            key: 'opportunity_area_acquisition_price',
            label: 'Acquisition Price per square meter',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Acquisition Price per square meter',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.opportunity.area_acquisition_price',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'money',
            key: 'opportunity_expected_area_valuation',
            label: 'Expected Land Valuation',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Expected Land Valuation',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.opportunity.expected_area_valuation',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'money',
            key: 'opportunity_development_cost',
            label: 'Project development costs',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Project development costs',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.opportunity.development_cost',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
        ],
      },
      {
        name: 'Opportunity Capital Structure',
        show_condition: ":project_id.type_slug === 'opportunity'",
        updated_field_keys: [],
        fields: [
          {
            type: 'number_input_field',
            key: 'opportunity_equity_ownership_percentage',
            label: 'Equity Ownership Percentage (%) cash',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Equity Ownership Percentage (%) cash',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.opportunity.equity_ownership_percentage',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'number_input_field',
            key: 'opportunity_equity_ownership_percentage_in_kind',
            label: 'Equity Ownership Percentage (%) in-kind',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Equity Ownership Percentage (%) in-kind',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation:
                ':project_id.opportunity.equity_ownership_percentage_in_kind',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'number_input_field',
            key: 'opportunity_financing_percentage',
            label: 'Financing Percentage',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Financing Percentage',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.opportunity.financing_percentage',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
        ],
      },
      {
        name: 'Opportunity Fees Specification',
        show_condition: ":project_id.type_slug === 'opportunity'",
        updated_field_keys: [],
        fields: [
          {
            type: 'table',
            key: 'opportunity_fees',
            label: 'Fees Overview',
            properties: {
              min: 0,
              max: 10,
              current_length: 0,
              equation: ':project_id.opportunity.fee_values',
              can_maintain_items: false,
              on_load_data: {
                api: 'https://dib.api.dev.kuiper.areebholding.work/api/v1/lookup/fees?tenant=dib',
                filters: [
                  {
                    key: 'not_ids',
                    value: 'opportunity_fee_id',
                    value_type: 'dynamic',
                    multiple: true,
                    required: false,
                  },
                  {
                    key: 'is_active',
                    value: '1',
                    value_type: 'static',
                    multiple: false,
                    required: false,
                  },
                ],
                data_type: 'array',
                data_key: 'fee',
              },
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            show_condition: ":project_id.type_slug === 'opportunity'",
            fields: [
              {
                type: 'lookup-simple',
                key: 'opportunity_fee_id',
                label: 'Fee Type',
                tooltip: null,
                value: null,
                properties: {
                  options: {
                    api: 'https://dib.api.dev.kuiper.areebholding.work/api/v1/lookup/fees?tenant=dib&access_throw=workflow',
                    filters: [
                      {
                        key: 'is_in_blocking_states',
                        value: '0',
                        value_type: 'static',
                        multiple: false,
                        required: true,
                      },
                      {
                        key: 'not_ids',
                        value: 'opportunity_fee_id',
                        value_type: 'dynamic',
                        multiple: true,
                        required: true,
                      },
                      {
                        key: 'is_active',
                        value: '1',
                        value_type: 'static',
                        multiple: false,
                        required: true,
                      },
                    ],
                    keys: {
                      label: 'label',
                      value: 'value',
                      icon: null,
                      tag: null,
                      hint: 'hint',
                      extraLabels: [],
                    },
                  },
                  on_select_data: [],
                  equation: ':fee',
                },
                can_answered: false,
                can_edit: true,
                is_required: true,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
              {
                type: 'money',
                key: 'opportunity_fee_source',
                label: 'Source (SAR)',
                tooltip: null,
                value: null,
                properties: {
                  placeholder: 'Source (SAR)',
                  min_decimal_places: 0,
                  max_decimal_places: 2,
                  equation: ':source',
                },
                can_answered: true,
                can_edit: true,
                is_required: false,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
              {
                type: 'number_input_field',
                key: 'opportunity_fee_percentage',
                label: 'Percentage (%)',
                tooltip: null,
                value: null,
                properties: {
                  placeholder: 'Percentage (%)',
                  min_decimal_places: 0,
                  max_decimal_places: 2,
                  equation: ':percentage',
                },
                can_answered: true,
                can_edit: true,
                is_required: false,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
              {
                type: 'money',
                key: 'opportunity_fee_value',
                label: 'Value (SAR)',
                tooltip: null,
                value: null,
                properties: {
                  placeholder: 'Value (SAR)',
                  min_decimal_places: 0,
                  max_decimal_places: 2,
                  equation:
                    ':opportunity_fee_source * :opportunity_fee_percentage / 100',
                },
                can_answered: false,
                can_edit: true,
                is_required: true,
                multiple: null,
                show_condition: null,
                disable_condition: null,
              },
            ],
          },
          {
            type: 'money',
            key: 'opportunity_total_fees',
            label: 'Total Fees (SAR)',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Total Fees (SAR)',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: 'sum(:opportunity_fees[opportunity_fee_value])',
            },
            can_answered: false,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
        ],
      },
      {
        name: 'SWOT Analysis',
        show_condition: ":project_id.type_slug === 'opportunity'",
        updated_field_keys: [],
        fields: [
          {
            type: 'dual_language_text',
            key: 'opportunity_strengths',
            label: 'Strengths',
            tooltip: null,
            value: null,
            properties: {
              equation: ':project_id.opportunity.translations.strengths',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'dual_language_text',
            key: 'opportunity_weaknesses',
            label: 'Weaknesses',
            tooltip: null,
            value: null,
            properties: {
              equation: ':project_id.opportunity.translations.weaknesses',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'dual_language_text',
            key: 'opportunity_opportunities',
            label: 'Opportunities',
            tooltip: null,
            value: null,
            properties: {
              equation: ':project_id.opportunity.translations.opportunities',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'dual_language_text',
            key: 'opportunity_threats',
            label: 'Threats',
            tooltip: null,
            value: null,
            properties: {
              equation: ':project_id.opportunity.translations.threats',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
        ],
      },
      {
        name: 'Cost-Benefit Analysis Specification',
        show_condition: ":project_id.type_slug === 'opportunity'",
        updated_field_keys: [],
        fields: [
          {
            type: 'money',
            key: 'opportunity_direct_costs',
            label: 'Direct Costs',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Direct Costs',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.opportunity.direct_costs',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'money',
            key: 'opportunity_indirect_costs',
            label: 'Indirect Costs',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Indirect Costs',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.opportunity.indirect_costs',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'money',
            key: 'opportunity_unassigned_costs',
            label: 'Unassessed Costs',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Unassessed Costs',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.opportunity.unassigned_costs',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'money',
            key: 'opportunity_opportunity_costs',
            label: 'Opportunity Costs',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Opportunity Costs',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.opportunity.opportunity_costs',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'money',
            key: 'opportunity_potential_risk_costs',
            label: 'Potential Risk Costs',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Potential Risk Costs',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.opportunity.potential_risk_costs',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'money',
            key: 'opportunity_fund_operational_load',
            label: 'Fund Operational Load',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Fund Operational Load',
              min_decimal_places: 0,
              max_decimal_places: 2,
              equation: ':project_id.opportunity.operational_load',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'drop_down_menu',
            key: 'opportunity_requirements_fund_operation',
            label: 'Requirements / Fund Operation',
            tooltip: null,
            value: null,
            properties: {
              placeholder: 'Requirements / Fund Operation',
              options: [
                {
                  value: 'high',
                  label: 'High',
                },
                {
                  value: 'medium',
                  label: 'Medium',
                },
                {
                  value: 'low',
                  label: 'Low',
                },
              ],
              equation: ':project_id.opportunity.requirements_fund_operation',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: null,
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
        ],
      },
      {
        name: 'Opportunity Legal documents',
        show_condition: ":project_id.type_slug === 'opportunity'",
        updated_field_keys: [],
        fields: [
          {
            type: 'media',
            key: 'opportunity_verification_documents',
            label: 'Verification Documents',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,rar,zip',
              max_file_size: 25600,
              equation: ':project_id.opportunity.verification_documents',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 10,
            },
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'media',
            key: 'opportunity_ownership_title_deed',
            label: 'Ownership Title Deed',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,rar,zip',
              max_file_size: 25600,
              equation: ':project_id.opportunity.ownership_title_deed',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 10,
            },
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'media',
            key: 'opportunity_power_of_attorney',
            label: 'Power of Attorney',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,rar,zip',
              max_file_size: 25600,
              equation: ':project_id.opportunity.power_of_attorney',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 10,
            },
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'media',
            key: 'opportunity_municipal_zoning_map',
            label: 'Municipal Zoning Map',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,rar,zip',
              max_file_size: 25600,
              equation: ':project_id.opportunity.municipal_zoning_map',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 10,
            },
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'media',
            key: 'opportunity_approved_site_plan',
            label: 'Approved Site Plan',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,rar,zip',
              max_file_size: 25600,
              equation: ':project_id.opportunity.approved_site_plan',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 10,
            },
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'media',
            key: 'opportunity_construction_license',
            label: 'Construction License',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,rar,zip',
              max_file_size: 25600,
              equation: ':project_id.opportunity.construction_license',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 10,
            },
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'media',
            key: 'opportunity_memorandum_of_association',
            label: 'Memorandum of Association',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,rar,zip',
              max_file_size: 25600,
              equation: ':project_id.opportunity.memorandum_of_association',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 10,
            },
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'media',
            key: 'opportunity_commercial_registration',
            label: 'Commercial Registration',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,rar,zip',
              max_file_size: 25600,
              equation: ':project_id.opportunity.commercial_registration',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 10,
            },
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'media',
            key: 'opportunity_national_id_residency',
            label: 'National ID/Residency',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,rar,zip',
              max_file_size: 25600,
              equation: ':project_id.opportunity.national_id_residency',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 10,
            },
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'media',
            key: 'opportunity_second_party_power_of_attorney',
            label: 'Second Party Power of Attorney',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,rar,zip',
              max_file_size: 25600,
              equation: ':project_id.opportunity.power_of_attorney_second',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 10,
            },
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
          {
            type: 'media',
            key: 'opportunity_other_documents',
            label: 'Other Documents',
            tooltip: null,
            value: null,
            properties: {
              extensions: 'pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,rar,zip',
              max_file_size: 25600,
              equation: ':project_id.opportunity.other_documents',
            },
            can_answered: true,
            can_edit: true,
            is_required: false,
            multiple: {
              min_size: 1,
              max_size: 10,
            },
            show_condition: ":project_id.type_slug === 'opportunity'",
            disable_condition: null,
          },
        ],
      },
    ],
    actions: [
      {
        value: 'submit',
        label: 'Submit',
        color: 'primary',
        group: null,
      },
    ],
    cancel_button: {
      label: 'Cancel',
      color: 'natural',
    },
  },
};

export const requestDetailsEmptyData = {
  id: 0,
  name: '',
  description: '',
  category: {
    id: 0,
    name: '',
  },
  current_position: 0,
  icon: {
    id: 0,
    name: '',
    mime_type: '',
    url: '',
    order: 0,
  },
  state: {
    value: '',
    label: '',
  },
  requirements: [],
  permissions: [],
  positions: [],
  creator: { id: 0, name: '' },
  sub_flow_templates_exists: false,
  is_triggable: false,
};
